import { useState, useEffect } from 'react'

const TOO_NARROW = 530

const checkIsNarrow = (): boolean => {
  if (window.innerWidth < TOO_NARROW) {
    return true
  }
  return false
}

export default function useIsNarrow(): boolean {
  const [isNarrow, setIsNarrow] = useState(checkIsNarrow)

  useEffect(() => {
    const handleResize = (): void => {
      setIsNarrow(checkIsNarrow)
    }

    window.addEventListener('resize', handleResize)
    return (): void => window.removeEventListener('resize', handleResize)
  }, [])

  return isNarrow
}
